// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mz-3";
export var downloadButton = "_mz-4";
export var fileContainer = "_mz-9 _mz-7";
export var fileContainerBase = "_mz-7";
export var fileContainerFixedHeight = "_mz-8 _mz-7";
export var fileInfo = "_mz-5";
export var fileInfoWidthRestricted = "_mz-6";
export var fileType = "_mz-1";
export var fileTypeName = "_mz-2";
export var image = "_mz-0";
export var link = "_mz-b";
export var overflowEllipsis = "_mz-a";